import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=088fe925&scoped=true"
import script from "./ContentItem.vue?vue&type=script&lang=js"
export * from "./ContentItem.vue?vue&type=script&lang=js"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=088fe925&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088fe925",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088fe925')) {
      api.createRecord('088fe925', component.options)
    } else {
      api.reload('088fe925', component.options)
    }
    module.hot.accept("./ContentItem.vue?vue&type=template&id=088fe925&scoped=true", function () {
      api.rerender('088fe925', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentView/ContentItem.vue"
export default component.exports